import React from 'react'
import { mergeProps } from 'src/util'
import Icon from '../Icon'
import styles from './SlashedIcon.scss'

const SlashedIcon = ({ icon, reversed, ...props }) => (
  <svg
    {...mergeProps()({
      className: ['fa-layers', styles[props.size]],
      style: { transform: 'scale(.9)', transformOrigin: 'center' },
    })}
  >
    <Icon icon="slash" transform={(reversed ? 'flip-h ' : '') + 'down-2.3 grow-4'} mask={icon} {...props} />
    <Icon icon="slash" transform={(reversed ? 'flip-h ' : '') + 'grow-2'} {...props} />
  </svg>
)

SlashedIcon.propTypes = {
  ...Icon.propTypes,
}

SlashedIcon.defaultProps = {
  size: 'md',
}
export default SlashedIcon
